<template>
  <div class="cont" id="brandClassroom2">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:31px;width:151px;margin-left:38px;margin-bottom:13px"
        :src="require('@/assets/image/brandClassroom/brandClassroom2/img1.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:16px;width:158px;margin-left:25px;margin-bottom:31px"
        :src="require('@/assets/image/brandClassroom/brandClassroom2/img2.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:26px;width:122px;margin-left:0;margin-bottom:0"
        :src="require('@/assets/image/brandClassroom/brandClassroom2/img3.png')"
        :fit="fit"
      ></el-image>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fit: "cover",
      animate: false ,
      screenHeight: window.innerHeight || document.documentElement.clientHeight ,

    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    var topPos = document.getElementById("brandClassroom2").offsetTop;
    if( scrollTop + this.screenHeight >  topPos ){
      this.animate = true 
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var topPos = document.getElementById("brandClassroom2").offsetTop;
      if( scrollTop + this.screenHeight >  topPos  ){
        this.animate = true 
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  background: url('~@/assets/image/brandClassroom/brandClassroom2/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.inner {
  position: absolute;
  width: 190px;
  height: 116px;
  left: 224px;
  top: 126px;
}
</style>